import { useState, useMemo, useEffect } from "react";
import { Subject, merge } from "rxjs";
import { mapTo, debounceTime, tap, delay } from "rxjs/operators";
import copy from "copy-text-to-clipboard";

export const useCopying: (item: string) => [
  boolean,
  InstanceType<typeof Subject>["next"]
] = (item) => {
  const [isCopying, setCopying] = useState<boolean>(false);
  const subject = useMemo(() => new Subject<void>(), []);

  useEffect(() => {
    const sub = merge<boolean>(
      subject.pipe(
        tap(() => copy(item)),
        mapTo(true)
      ), // TODO: use actual aff link
      subject.pipe(debounceTime(300), mapTo(false), delay(1000))
    ).subscribe((x) => setCopying(x));

    return () => sub.unsubscribe();
  }, [item]);

  return [isCopying, () => subject.next()];
};
